import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { reverseTranslate } from "../utils/currency";
import { IAddingRateBox } from "../utils/types";
import { transactionTypes } from "../utils/utils";
import { translate } from "../utils/currency";
import { changeMerchRates, putProvRates } from "../utils/api";
import { useAuthStore } from "../store/authStore";
import { useState } from "react";
const AddingRateBox: React.FC<IAddingRateBox> = ({
  form,
  currency,
  methods,
  setForm,
  type,
  merchantId,
  dialogRef,
  providerId,
  fetchDataP,
  fetchData,
}) => {
  const { changeCurrency } = useAuthStore();

  /**
   * Платёжная страница: «не трогаем» — это отдельное состояние, а не значение.
   * Бэкенд различает отсутствие поля (оставить как есть) и null (сбросить к
   * поведению по умолчанию), поэтому нетронутый выбор не отправляется вовсе.
   */
  const [paymentForm, setPaymentForm] = useState<
    "keep" | "page" | "api" | "default"
  >("keep");
  const [ttlMode, setTtlMode] = useState<"keep" | "default" | "custom">("keep");
  const [ttlValue, setTtlValue] = useState<string>("900");

  const paymentFormValue = () => {
    if (paymentForm === "keep") return undefined;
    if (paymentForm === "page") return true;
    if (paymentForm === "api") return false;
    return null;
  };

  const ttlSecondsValue = () => {
    if (ttlMode === "keep") return undefined;
    if (ttlMode === "default") return null;
    const parsed = Number(ttlValue);
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  return (
    <Box
      margin="0 auto"
      width="98%"
      display="flex"
      gap="15px"
      flexDirection={"column"}
    >
      <FormControl sx={{ width: "100%" }} fullWidth>
        <InputLabel
          sx={{
            "&.MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
              top: 6,
            },
          }}
        >
          Тип транзакции
        </InputLabel>
        <Select
          onChange={(e) =>
            setForm((prev) => ({
              ...prev,
              operation_type: e.target.value,
            }))
          }
          MenuProps={{
            disableScrollLock: true,
          }}
          value={form.operation_type}
          sx={{ height: "68px" }}
          label="Тип транзакции"
        >
          {transactionTypes.map((trans) => (
            <MenuItem key={trans} value={trans}>
              <Typography>{trans}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        value={form.rate}
        onChange={(event) =>
          setForm((prev) => ({
            ...prev,
            rate: event.target.value,
          }))
        }
        id="rate"
        label="Ставка"
        slotProps={{
          htmlInput: {
            step: "any",
          },
        }}
        type="number"
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            height: "68px",
            alignItems: "center",
          },
          "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
            top: 6,
          },
        }}
      />

      <TextField
        value={form.minsum}
        onChange={(event) =>
          setForm((prev) => ({
            ...prev,
            minsum:
              event.target.value === "" ? null : Number(event.target.value),
          }))
        }
        id="rate"
        label="Мин. сумма"
        slotProps={{
          htmlInput: {
            step: "any",
          },
        }}
        type="number"
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            height: "68px",
            alignItems: "center",
          },
          "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
            top: 6,
          },
        }}
      />

      <TextField
        value={form.maxsum}
        onChange={(event) =>
          setForm((prev) => ({
            ...prev,
            maxsum:
              event.target.value === "" ? null : Number(event.target.value),
          }))
        }
        id="rate"
        label="Макс. сумма"
        slotProps={{
          htmlInput: {
            step: "any",
          },
        }}
        type="number"
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            height: "68px",
            alignItems: "center",
          },
          "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
            top: 6,
          },
        }}
      />
      <FormControl sx={{ width: "100%" }} fullWidth>
        <InputLabel
          sx={{
            "&.MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
              top: 6,
            },
          }}
        >
          Валюта
        </InputLabel>
        <Select
          onChange={(e) =>
            setForm((prev) => ({
              ...prev,
              currency: e.target.value,
            }))
          }
          value={form.currency}
          MenuProps={{
            disableScrollLock: true,
          }}
          id="currency"
          label="Валюта"
          sx={{ height: "68px" }}
        >
          {Object.entries(currency).map(([key, value]) => (
            <MenuItem key={key} value={value.label}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography>{value?.label}</Typography>
                <img
                  src={value?.img}
                  alt={value?.label}
                  width={35}
                  height={35}
                  style={{ objectFit: "contain" }}
                />
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ width: "100%" }} fullWidth>
        <InputLabel
          sx={{
            "&.MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
              top: 6,
            },
          }}
        >
          Метод
        </InputLabel>
        <Select
          value={form.payment_method}
          MenuProps={{
            disableScrollLock: true,
          }}
          onChange={(e) =>
            setForm((prev) => ({
              ...prev,
              payment_method: e.target.value,
            }))
          }
          label="Метод"
          sx={{ height: "68px" }}
        >
          {Object.entries(methods).map(([key, value]) => (
            <MenuItem key={key} value={value}>
              <Typography>{translate(value)}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {type === "merchant" && (
        <>
          <FormControl sx={{ width: "100%", mt: 2 }}>
            <InputLabel shrink>Платёжная страница</InputLabel>
            <Select
              value={paymentForm}
              label="Платёжная страница"
              onChange={(event) => setPaymentForm(event.target.value as any)}
            >
              <MenuItem value="keep">Не менять</MenuItem>
              <MenuItem value="page">Ссылка на нашу страницу</MenuItem>
              <MenuItem value="api">Реквизиты в ответе API</MenuItem>
              <MenuItem value="default">Как в общем списке</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="caption" color="text.secondary">
            «Не менять» ничего не отправляет и сохраняет прежнюю настройку. «Как
            в общем списке» сбрасывает её к поведению по умолчанию.
          </Typography>

          <FormControl sx={{ width: "100%", mt: 2 }}>
            <InputLabel shrink>Срок жизни страницы</InputLabel>
            <Select
              value={ttlMode}
              label="Срок жизни страницы"
              onChange={(event) => setTtlMode(event.target.value as any)}
            >
              <MenuItem value="keep">Не менять</MenuItem>
              <MenuItem value="default">По умолчанию, 900 секунд</MenuItem>
              <MenuItem value="custom">Задать вручную</MenuItem>
            </Select>
          </FormControl>
          {ttlMode === "custom" && (
            <TextField
              label="Секунд"
              type="number"
              value={ttlValue}
              onChange={(event) => setTtlValue(event.target.value)}
              helperText="От 60 до 86400"
              sx={{ width: "100%", mt: 1 }}
            />
          )}
        </>
      )}

      <Button
        variant="contained"
        onClick={() => {
          setForm({
            operation_type: null,
            currency: null,
            rate: null,
            payment_method: null,
            minsum: null,
            maxsum: null,
          });
          dialogRef.current?.closeDialog();
        }}
        sx={{
          width: "100%",
        }}
      >
        Отмена
      </Button>
      <Button
        onClick={async () => {
          if (type === "merchant") {
            await changeMerchRates({
              merchant_id: Number(merchantId),
              currency: reverseTranslate(form.currency).toLowerCase(),
              payment_method: form.payment_method ?? "",
              rate: Number(form.rate),
              operation_type: form.operation_type?.toLowerCase() ?? "",
              minsum: Number(form.minsum),
              maxsum: Number(form.maxsum),
              use_payment_form: paymentFormValue(),
              payment_ttl_seconds: ttlSecondsValue(),
            });
            dialogRef.current?.closeDialog();
            setForm({
              operation_type: null,
              currency: null,
              rate: null,
              payment_method: null,
            });
            changeCurrency(reverseTranslate(form.currency));
            await fetchData?.();
          } else {
            await putProvRates(
              Number(providerId),
              form.payment_method ?? "",
              form.operation_type?.toLowerCase() ?? "",
              reverseTranslate(form.currency).toLowerCase(),
              Number(form.rate),
              Number(form.minsum),
              Number(form.maxsum),
            );
            dialogRef.current?.closeDialog();
            setForm({
              operation_type: null,
              currency: null,
              rate: null,
              payment_method: null,
              minsum: null,
              maxsum: null,
            });
            await fetchDataP?.();
          }
        }}
        variant="contained"
      >
        Создать
      </Button>
    </Box>
  );
};
export default AddingRateBox;
